export default {
    namespaced: true,
    state: {
        view: 'training',
        selectedLesson: null,
        fileIcons: {
            doc: {
                icon: 'fa-file-word',
                color: '#2B579A'
            },
            docx: {
                icon: 'fa-file-word',
                color: '#2B579A'
            },
            xls: {
                icon: 'fa-file-excel',
                color: '#317347'
            },
            xlsx: {
                icon: 'fa-file-excel',
                color: '#317347'
            },
            pdf: {
                icon: 'fa-file-pdf',
                color: '#B42824'
            }
        }
    }
}